import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonHeader, IonContent } from '@ionic/react'
import { getPlatform } from '@utils'
import './index.scss'

const { isWeixinMiniProgram } = getPlatform()

interface IProps {
  reject: () => void;
  resolve: (val: number) => void;
}

const BuyTypeModal: FC<IProps> = (props: IProps) => {
  const {
    reject,
    resolve,
  } = props
  return (
    <IonModal
      data-cypid='mmgBuyTypeModal'
      cssClass='buy-type-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span>{i18n.t('mkt.coupon.chooseCate')}</span>
        <i data-cypid='mmgCloseBuyType' className='iconfont icon-close' onClick={reject}></i>
      </IonHeader>
      <IonContent className='type-panel'>
        <div className='type-area'>
          {
            isWeixinMiniProgram && Config.miniVersion >= 102221213 &&
              <div data-cypid='mmgBuyToWechat' className='type-item' onClick={() => resolve(2)}>
                <i className='iconfont icon-wechat'></i>
                <div className='type-item-text'>{i18n.t('mkt.giftCard.wechatGive')}</div>
              </div>
          }
          <div data-cypid='mmgBuyToEmail' className='type-item' onClick={() => resolve(0)}>
            <i className='iconfont icon-youjian'></i>
            <div className='type-item-text'>{i18n.t('mkt.coupon.emailFor')}</div>
          </div>
          <div data-cypid='mmgBuyToSelf' className='type-item' onClick={() => resolve(1)}>
            <i className='iconfont icon-weibiaoti-1'></i>
            <div className='type-item-text'>{i18n.t('mkt.giftCard.buyType2')}</div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(BuyTypeModal)
